/**
 * 평형 타입명 정규화 (frontend 안전망).
 *
 * backend api/models.py 의 normalize_type_name() 과 동일 규칙:
 *   - 앞의 0 제거 (084 → 84)
 *   - 소수점 + 소수부 제거 (084.9918A → 84A)
 *   - 알파벳 / 하이픈 접미사 유지
 *
 * 예시:
 *   '084.9918A' → '84A'
 *   '046.6893B' → '46B'
 *   '136.9181'  → '136'
 *   '84A'       → '84A' (변경 없음)
 *   '119'       → '119' (변경 없음)
 *   ''          → ''
 *
 * 사용처:
 *   - PropertyDetailPage 평형 라벨 (기본단지정보)
 *   - FloorplanTabbed chip 라벨
 *   - TypePriceTable 행 헤더
 *   - SEO alt 텍스트 빌더 (seoUtils)
 *
 * backend save() hook 이 정상 작동하면 frontend 가 굳이 정규화할 필요 없지만,
 * 과거 import / 직접 SQL 로 들어간 미정규화 데이터를 화면에서 깨지지 않게 하기 위함.
 */
export function normalizeTypeName(s: string | null | undefined): string {
  if (!s) return '';
  const raw = String(s).trim();
  if (!raw) return '';
  const m = raw.match(/^0*(\d+)(?:\.\d+)?\s*([A-Za-z-]*)$/);
  return m ? `${m[1]}${m[2]}` : raw;
}
